import {take, cancel, fork} from 'redux-saga/effects';
import EditableActions from "../../EditableTable/actions";
import {TableName} from "../../EditableTable/options";
import TransactionActions from "../actions";
import ListActions from "../../List/actions";
import {calculateAll} from "./calculateAll";

function* safe(saga, ...args) {
    try {
        const result = yield saga(...args);
        return { result };
    }
    catch (err) {
        console.error(err);
        return { err };
    }
}

export function* listenForTransactionCalculations(props) {
    const { action: initRequestAction } = props;

    const editableActions = [
        EditableActions.SET_ITEMS,
        EditableActions.SET_ITEM,
        EditableActions.ADD_ITEM,
        EditableActions.ADD_ITEMS,
        EditableActions.REMOVE_ITEM,
        EditableActions.SET_LINKED_ITEMS,
    ];

    const transactionActions = [
        TransactionActions.TRANSACTION_CHANGE,
        TransactionActions.TRANSACTION_SET_ROUNDING_ON,
        TransactionActions.TRANSACTION_CHANGE_TAX_MODE,
        TransactionActions.TRANSACTION_CHANGE_LINK_ITEM,
        TransactionActions.TRANSACTION_CHANGE_LINK_ITEMS,
        TransactionActions.TRANSACTION_SET_APPLIED_LINKED_IDS,
        TransactionActions.TRANSACTION_ADD_TO_APPLIED_LINKED_IDS,
        TransactionActions.TRANSACTION_REMOVE_APPLIED_LINKED_ID,
        TransactionActions.TRANSACTION_CLEAR_APPLIED_LINKED_IDS,
    ];

    const listActions = [
        ListActions.LIST_READ_LISTS_SUCCESS,
    ];

    // Returns: boolean
    function canStartCalculation(action) {
        // Editable Actions
        if (
            editableActions.includes(action.type) &&
            (action.name === TableName.form_item || action.name === TableName.bank_item) &&
            !action.skipCalculation
        )
            return true;

        // Transaction Actions
        if (
            transactionActions.includes(action.type)
        )
            return true;

        // List Actions
        if (
            listActions.includes(action.type) &&
            action?.responseData?.tax_codes
        )
            return true;

        return false;
    }

    const allPatterns = [...editableActions, ...transactionActions, ...listActions];

    // Start with one calculation
    // const action = yield take(allPatterns);
    yield fork(function* () {
        yield safe(calculateAll, {initRequestAction});
    });

    let lastTask;
    while (true) {
        const action = yield take(allPatterns);
        if (canStartCalculation(action)) {
            if (lastTask)
                yield cancel(lastTask);

            lastTask = yield fork(function* () {
                yield safe(calculateAll, {initRequestAction});
            });
        }
    }
}
